import BuildShow from "../components/build/Show";

export default [
  { name: 'Build', path: '/build', component: BuildShow,  }
]
